<template>
  <v-container>
    <v-row justify="center">
      <v-col
        align="center"
        cols="6"
        md="2"
        :class="providerQportal"
        style="cursor:pointer;"
        @click="changeProvider('qportal')"
      >
        <v-icon color="#066a8c">mdi-post-outline</v-icon>
        <div class="mnuBtn">QPortal</div>
      </v-col>

      <v-col
        align="center"
        cols="6"
        md="2"
        :class="providerPriohub"
        @click="changeProvider('priohub')"
        style="cursor:pointer;"
      >
        <v-icon color="#066a8c">mdi-view-dashboard</v-icon>
        <div class="mnuBtn">Priohub</div>
      </v-col>
    </v-row>
    <v-row>
      <div class="md-card md-theme-default">
        <div class="md-card-content">
          <div>
            <div class="header_title">
              <v-row no-gutters class="ma-3 header_title">
                <v-col cols="12" md="2" class="pt-6">
                  Services
                  <br />
                  <br />
                </v-col>

                <v-col cols="12" md="10">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="3">
                      <v-btn
                        height="38"
                        class="green-color"
                        width="100%"
                        dark
                        @click="syncQportalServices"
                      >
                        Sync with Qportal

                        <v-icon right dark>mdi-sync</v-icon>
                      </v-btn>
                    </v-col>
                    <!-- <v-col
                      cols="12"
                      md="2"
                      sm="1"
                      class="text-right"
                      v-if="this.serviceForm.third_party == 'priohub'"
                    >
                      <v-btn
                        height="38"
                        class="green-color"
                        width="100%"
                        dark
                        @click="addService"
                      >
                        Add Service
                        <v-icon right dark>mdi-plus-circle</v-icon>
                      </v-btn>
                    </v-col> -->
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div
              class="md-content md-table md-theme-default table_borders"
              table-header-color="orange"
              value
            >
              <div
                class="
                  md-content md-table-content md-scrollbar md-theme-default
                "
              >
                <table>
                  <thead class="md-card-header">
                    <tr>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Service Name</div>
                        </div>
                      </th>

                      <!-- <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Qportal</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Priohub</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Based On</div>
                        </div>
                      </th> -->
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Service Type</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Description</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Action</div>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      class="md-table-row"
                      v-for="(data, index) in services"
                      :key="index"
                    >
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.service_name || "NA" }}
                        </div>
                      </td>
                      <!-- <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.qportal_service_name || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.priohub_service_name || "NA" }}
                        </div>
                      </td> -->
                      <!-- <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{
                            data.is_capacity_based == 0
                              ? "Time based"
                              : "Capacity based" || "NA"
                          }}
                        </div>
                      </td> -->
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.service_type }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.description || "NA" }}
                        </div>
                      </td>

                      <td class="md-table-cell" style="min-width: 120px">
                        <v-btn
                          x-small
                          :color="data.status_id == 1 ? 'success' : 'error'"
                          class="d-inline-block text-truncate"
                          dark
                          @click="changeServiceStatus(data.id, index)"
                          fab
                        >
                          <v-icon dark>{{ "mdi-delete" }}</v-icon></v-btn
                        >&nbsp;&nbsp;

                        <v-btn
                          x-small
                          color="#00b0af"
                          class="d-inline-block text-truncate"
                          dark
                          fab
                          @click="editServices(data.id)"
                        >
                          <v-icon dark>mdi-pencil</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="totalPages"
              :page="page"
              total-visible="10"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-row>
    <v-dialog
      v-model="addServiceModel"
      persistent
      max-width="40%"
      scrollable
      v-resize="onResize"
    >
      <v-card ref="card">
        <v-card-title class="headline"
          >{{ editFlag ? "Update" : "Add" }} Service</v-card-title
        >
        <v-card-text class="form_bg">
          <v-container>
            <v-form v-on:submit.prevent ref="form" v-model="valid">
              <v-row>
                <v-col md="12">
                  <v-row no-gutters justify="center">
                    <v-col sm="11">
                      <image-upload
                        @upload="
                          (data) => {
                            serviceForm.image = data;
                          }
                        "
                        @remove="
                          () => {
                            serviceForm.profile_image = null;
                          }
                        "
                        :image_path="serviceForm.image_path"
                        :height="200"
                        ref="image_upload"
                      ></image-upload>
                    </v-col>
                  </v-row>
                  <v-row class="ma-1">
                    <v-col cols="12">
                      <v-text-field
                        v-model="serviceForm.name"
                        :rules="nameRules"
                        label="Service Name"
                        required
                        outlined
                        background-color="#fff"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="serviceForm.third_party == 'qportal'"
                    >
                      <v-select
                        label="Select Service"
                        v-model="changeQportalService"
                        item-value="id"
                        item-text="name"
                        :items="qportalServiceList"
                        outlined
                        return-object
                        background-color="#fff"
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      v-else-if="serviceForm.third_party == 'priohub'"
                    >
                      <v-select
                        label="Select Service"
                        v-model="changePriohubService"
                        item-value="id"
                        item-text="category_name"
                        :items="priohubServiceList"
                        return-object
                        outlined
                        background-color="#fff"
                      ></v-select>
                    </v-col>
                    <v-col md="12">
                      <v-radio-group
                        class="d-flex"
                        label="Service Type"
                        v-model="serviceForm.serviceType"
                        row
                        mandatory
                        :rules="[(v) => !!v || 'Service Type is required']"
                      >
                        <v-radio
                          label="Sports"
                          color="primary"
                          value="sports"
                        ></v-radio>
                        <v-radio
                          label="Social"
                          color="primary"
                          value="social"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col md="12" v-if="serviceForm.third_party == 'qportal'">
                      <v-autocomplete
                        :items="playerCombinations"
                        v-model="serviceForm.player_combination_ids"
                        item-value="id"
                        item-text="name"
                        label="Player Combinations"
                        outlined
                        multiple
                        background-color="#fff"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item ripple @click="toggleSelect()">
                            <v-list-item-action>
                              <v-icon
                                :color="
                                  serviceForm.player_combination_ids !=
                                    undefined &&
                                  serviceForm.player_combination_ids.length > 0
                                    ? 'indigo darken-4'
                                    : ''
                                "
                                >{{ getIcon() }}</v-icon
                              >
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>All</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>

                        <template
                          v-if="
                            serviceForm.player_combination_ids != undefined &&
                              serviceForm.player_combination_ids.length ==
                                playerCombinations.length
                          "
                          v-slot:selection="{ index }"
                        >
                          <span v-if="index == 0">All Player Combinations</span>
                        </template>
                        <template v-else v-slot:selection="{ item, index }">
                          <span v-if="index == 0">{{ item.name }}</span>
                          <span v-if="index == 1">, {{ item.name }}</span>
                          <span v-if="index == 2">, ...</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <!-- <v-col md="12">
                      <v-radio-group
                        class="d-flex"
                        label="Based on"
                        v-model="serviceForm.perCapacity"
                        row
                        mandatory
                        :rules="[(v) => !!v || 'Type is required']"
                      >
                        <v-radio
                          label="Time"
                          color="primary"
                          value="0"
                        ></v-radio>
                        <v-radio
                          label="Capacity"
                          color="primary"
                          value="1"
                        ></v-radio>
                      </v-radio-group>
                    </v-col> -->

                    <v-col sm="12">
                      <v-textarea
                        name="description"
                        label="About Service"
                        v-model="serviceForm.description"
                        value
                        outlined
                        background-color="#fff"
                        rows="3"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-2 white--text blue-color"
            text
            @click="addUpdateService"
            >{{ editFlag ? "Update" : "Add" }} Service</v-btn
          >

          <v-btn class="ma-2 white--text green-color" text @click="cancelForm"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      providerQportal: "btn_bg",
      providerPriohub: null,
      items: ["Sports", "Entertaintment"],
      categoryId: "",
      addServiceModel: false,
      qportalServices: [],
      priohubServices: [],
      services: [],
      serviceForm: {
        third_party: "qportal",
      },
      image_path: null,
      page: 1,
      totalPages: 1,
      show2: false,
      valid: true,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => (v && v.length >= 6) || "Min 6 characters",
      },
      nameRules: [(v) => !!v || "Name is required"],
      category: null,
      editFlag: false,
      modules: [],
      subModules: [],
      service: {},
      height: 500,
      selectAll: false,
      changeQportalService: false,
      changePriohubService: false,
    };
  },
  mounted() {
    this.getServices();
    if (this.$store.getters.getQportalServices.status == false) {
      this.$store.dispatch("loadQportalServices");
    }
    if (this.$store.getters.getPlayerCombinations.status == false) {
      this.$store.dispatch("loadPlayerCombinations");
    }
    this.$store.dispatch("loadPriohubServices");
  },
  computed: {
    qportalServiceList() {
      console.log("Q");
      console.log(this.$store.getters.getQportalServices.data);
      return this.$store.getters.getQportalServices.data.data;
    },
    priohubServiceList() {
      const priohubServices = this.$store.getters.getPriohubServices.data.map(
        (item) => {
          return {
            id: parseInt(item.category_id),
            category_name: item.category_name,
            category_type: item.category_type,
            category_icon: item.category_icon,
          };
        }
      );
      console.log("P");
      console.log(priohubServices);
      return priohubServices;
    },
    playerCombinations() {
      return this.$store.getters.getPlayerCombinations.data;
    },
  },
  watch: {
    page() {
      this.getServices();
    },
    changeQportalService(value) {
      this.serviceForm.qportal_service_id = value.id;
      this.serviceForm.qportal_service_name = value.name;
    },
    changePriohubService(value) {
      this.serviceForm.priohub_service_id = value.id;
      this.serviceForm.priohub_service_name = value.category_name;
    },
  },
  methods: {
    getIcon() {
      if (
        this.serviceForm.player_combination_ids &&
        this.serviceForm.player_combination_ids.length == 0
      )
        return "mdi-checkbox-blank-outline";

      if (
        this.serviceForm.player_combination_ids &&
        this.playerCombinations.length ==
          this.serviceForm.player_combination_ids.length
      )
        return "mdi-close-box";
      return "mdi-minus-box";
    },
    toggleSelect() {
      this.$nextTick(() => {
        if (
          this.serviceForm.player_combination_ids &&
          this.playerCombinations.length ==
            this.serviceForm.player_combination_ids.length
        ) {
          this.serviceForm.player_combination_ids = [];
        } else {
          this.serviceForm.player_combination_ids = this.playerCombinations.map(
            (item) => item.id
          );
        }
        this.$forceUpdate();
      });
    },
    getServices() {
      let url = "";
      if (this.serviceForm.third_party == "priohub") {
        url += "&provider=PRIOHUB";
      } else {
        url += "&provider=QPORTAL";
      }
      let apiUrl = "settings/services?per_page=10&page=" + this.page + url;

      this.$http
        .get(apiUrl)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.services = response.data.data;
            this.totalPages = response.data.total_pages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    editServices(id) {
      console.log(this.serviceForm.third_party + "dcjkcsdkj");
      if (typeof id != "undefined") {
        this.editFlag = true;
        this.$http
          .get("settings/services/" + id)
          .then((response) => {
            if (response.status == 200) {
              let data = response.data.data;
              this.serviceForm.name = data.service_name;

              this.changeQportalService = {
                id: data.qportal_service_id,
              };
              this.changePriohubService = {
                id: data.priohub_service_id,
              };
              this.serviceForm.id = data.id;
              this.serviceForm.image_path = data.image;
              this.serviceForm.perCapacity = data.is_capacity_based;
              this.serviceForm.serviceType = data.service_type;
              this.serviceForm.player_combination_ids = data.player_combinations.map(
                (item) => item.id
              );
              //this.serviceForm.player_combinations = data.player_combinations;
              this.addServiceModel = true;
              setTimeout(() => {
                this.$refs["image_upload"].cancel();
                this.$refs.form.resetValidation();
              });
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
      }
    },
    addService() {
      this.serviceForm = {};
      this.serviceForm.third_party = "priohub";
      this.changeQportalService = false;
      this.changePriohubService = false;
      this.serviceForm.image_path = null;
      this.addServiceModel = true;
      this.data = [];
      setTimeout(() => {
        this.$refs["image_upload"].cancel();
        this.$refs.form.resetValidation();
      });
    },
    searchFIlter() {
      this.page = 1;
      this.getServices();
    },
    addUpdateService() {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }
      let formData = new FormData();
      formData.set("service_name", this.serviceForm.name);
      if (this.serviceForm.image) {
        formData.set("image", this.serviceForm.image);
      }
      if (this.serviceForm.description)
        formData.set("description", this.serviceForm.description);
      // if (this.serviceForm.perCapacity)
      //   formData.set("is_capacity_based", this.serviceForm.perCapacity);
      if (this.serviceForm.serviceType)
        formData.set("service_type", this.serviceForm.serviceType);
      if (this.serviceForm.image) {
        formData.set("image", this.serviceForm.image);
      }
      formData.set(`third_party[0][type]`, "qportal");
      if (
        this.serviceForm.qportal_service_id &&
        this.serviceForm.qportal_service_id != undefined &&
        this.serviceForm.qportal_service_name != undefined
      ) {
        formData.set(
          `third_party[0][service_id]`,
          this.serviceForm.qportal_service_id
        );
        formData.set(
          `third_party[0][service_name]`,
          this.serviceForm.qportal_service_name
        );
      }
      if (
        this.serviceForm.priohub_service_id &&
        this.serviceForm.priohub_service_id != undefined &&
        this.serviceForm.priohub_service_name != undefined
      ) {
        formData.set(`third_party[1][type]`, "priohub");
        formData.set(
          `third_party[1][service_id]`,
          this.serviceForm.priohub_service_id
        );
        formData.set(
          `third_party[1][service_name]`,
          this.serviceForm.priohub_service_name
        );
      }
      if (this.serviceForm.id) {
        formData.set("id", this.serviceForm.id);
      }
      if (this.serviceForm.player_combination_ids)
        formData.set(
          "player_combination_ids",
          this.serviceForm.player_combination_ids
        );
      this.$http({
        url:
          "settings/services" +
          (this.serviceForm.id ? `/${this.serviceForm.id}` : ""),
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
        .then((response) => {
          if (response.status == 200) {
            this.addServiceModel = false;
            this.showSuccess("Service Added Successfully.");
            this.getServices();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    syncQportalServices() {
      this.showLoader();
      let url = "settings/sync-services";
      this.$http
        .get(url)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.hideLoader();
            this.getServices();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    changeServiceStatus(id, index) {
      this.$http
        .put(`settings/services/${id}/status`)
        .then((response) => {
          if (response.status == 200) {
            let status = response.data.data.status_id;
            this.services[index].status_id = status;
            this.getServices();
            this.showSuccess(`Service Deleted successfully`);
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    changeProvider(sel) {
      if (sel == "qportal") {
        this.serviceForm.third_party = "qportal";
        this.providerQportal = "btn_bg";
        this.providerPriohub = "";
      } else {
        this.serviceForm.third_party = "priohub";
        this.providerPriohub = "btn_bg";
        this.providerQportal = "";
      }
      // this.changeThirdParty();
      this.getServices();
      this.$forceUpdate();
    },
    cancelForm() {
      this.$refs.form.resetValidation();
      this.addServiceModel = false;
      this.serviceForm = {};
      this.editFlag = false;
    },
    onResize() {
      if (this.$refs.card) this.height = this.$refs.card.$el.clientHeight - 100;
    },
  },
};
</script>
<style scoped>

.validation-message {
  color: red;
  font-size: 12px;
}
.md-card {
  margin: 0 0 25px 0;
}
.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}
.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
</style>
